// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/panel-left-close.js';

import { paths } from '../generated/panel-left-close';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('panel-left-close', Original, paths);
